// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"6760d053","81":"6f41dcc7","88":"5445f945","213":"323392a6","271":"7ea9cb8b","349":"489b499b","442":"cef163da","474":"81ba3ae3","488":"afd6e9c2","586":"dd48488b","596":"8a7cfdb5","662":"e261623d","732":"e04df595","748":"eb3819d4","762":"c863f8ae"}[chunkId] + ".chunk.js";
};